import { SavingOfTotalEconomy } from "@portal/types/robot/IRobotEnums";

export const IsChecked = (index: number, savingOfTotalEconomy: SavingOfTotalEconomy | null) => {
  if (index === 0) return savingOfTotalEconomy === SavingOfTotalEconomy.Smaller;
  if (index === 1) return savingOfTotalEconomy === SavingOfTotalEconomy.Larger;
  return undefined;
};
